export default {
  namespaced: true,
  state: { timeoutId: null },
  actions: {
    show({ state, commit }, modal) {
      modal.show("public-profile-modal");

      if (state.timeoutId !== null) {
        clearTimeout(state.timeoutId);
        commit("setTimeoutId", null);
      }
    },
    startTimeout({ commit, rootGetters }, modal) {
      if (rootGetters["user/auth"]) {
        return;
      }

      let timeoutId = setTimeout(() => {
        modal.show("public-profile-modal");
      }, 5000);

      commit("setTimeoutId", timeoutId);
    }
  },
  mutations: {
    setTimeoutId(state, timeoutId) {
      state.timeoutId = timeoutId;
    }
  },
  getters: {}
};
